const BOLD = 700;
const SEMI_BOLD = 600;
const MEDIUM = 500;
const REGULAR = 400;

const weights = { BOLD, SEMI_BOLD, MEDIUM, REGULAR };

export default weights;
